/**
 * NOTICE OF LICENSE
 *
 * @author    202 ecommerce <tech@202-ecommerce.com>
 * @author    Mondial Relay
 * @copyright Copyright (c) Mondial Relay
 * @license http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 */

// modules ES6
import * as MR_Widget from '../../mondialrelay_widget';

export let removeCarrier = () => {
  for (let [id_carrier, carrier] of Object.entries(MONDIALRELAY_CARRIER_METHODS)) {
    if (
        (['ES', 'IT', 'PT'].includes(MONDIALRELAY_COUNTRY_ISO) && carrier.delivery_type !== "IP") ||
        (!['ES', 'IT', 'PT'].includes(MONDIALRELAY_COUNTRY_ISO) && carrier.delivery_type !== "MR") ||
        !MONDIALRELAY_ADDRESS_OPC
    ) {
      if ((carrier = $('[name^="delivery_option"][value="' + id_carrier + ',"]')[0])) {
        pointCarrier(carrier, remove);
      }
    }
  }
}

let pointCarrier = (carrier, callback) => {
  let deliveryOption;
  if ((deliveryOption = carrier.closest('.delivery-option') || carrier.closest('.delivery_option'))) {
    callback(deliveryOption);
  }
}

let remove = (deliveryOption) => {
  deliveryOption.remove();
}


const widget = MR_Widget.widget;
let saveRelayGeneration = 0;
let activeSaveRelayRequest = null;
let clearRelayGeneration = 0;
let activeClearRelayRequest = null;
let relaySelectionInvalidated = false;

const isRelayCarrierSelected = () => {
  const selectedCarrierId = getSelectedCarrierId();

  return selectedCarrierId !== false
      && MONDIALRELAY_NATIVE_RELAY_CARRIERS_IDS.map(String).includes(String(selectedCarrierId));
};

const getSelectedCarrierId = () => {
  let id = $('[name^="delivery_option"]:checked').val();
  if (typeof id !== 'undefined') {
      let new_id = id.split(',');
      id = new_id[0];
  }
  return id ? id : false;
};

const getCarrierDeliveryMode = (id_carrier) => {
  return MONDIALRELAY_CARRIER_METHODS[id_carrier]
      ? MONDIALRELAY_CARRIER_METHODS[id_carrier]['delivery_mode']
      : null;
};

const getRelaySelectionError = () => {
  const deliveryMode = getCarrierDeliveryMode(getSelectedCarrierId());

  return typeof MONDIALRELAY_SELECTION_ERRORS !== 'undefined'
      && MONDIALRELAY_SELECTION_ERRORS[deliveryMode]
    ? MONDIALRELAY_SELECTION_ERRORS[deliveryMode]
    : MONDIALRELAY_NO_SELECTION_ERROR;
};

const hasPersistedRelayData = () => {
  return Boolean(
    MONDIALRELAY_SELECTED_RELAY_IDENTIFIER
    && MONDIALRELAY_SELECTED_RELAY_INFOS
    && MONDIALRELAY_SELECTED_RELAY_INFOS.ID
    && MONDIALRELAY_SELECTED_RELAY_INFOS.CP
    && MONDIALRELAY_SELECTED_RELAY_INFOS.Pays
  );
};

const isPersistedRelayValid = () => {
  return !relaySelectionInvalidated && isRelayCarrierSelected() && hasPersistedRelayData();
};

const syncPersistedRelay = () => {
  if (isPersistedRelayValid()) {
    widget.savedRelay = MONDIALRELAY_SELECTED_RELAY_IDENTIFIER;
    widget.restorePersistedRelay();
    $(widget.summary_container).show();
    $(widget.save_container).hide();
    widget.hide();
    return true;
  }

  widget.savedRelay = null;
  $(widget.summary_container).hide();

  if (relaySelectionInvalidated || !isRelayCarrierSelected()) {
    widget.resetSelectedRelay();
  }

  return false;
};

const clearPersistedRelay = () => {
  const hadPersistedRelay = Boolean(MONDIALRELAY_SELECTED_RELAY_IDENTIFIER || widget.savedRelay);
  relaySelectionInvalidated = true;
  widget.resetSelectedRelay();
  widget.resetSavedRelay(true);
  $(widget.summary_container).hide().empty();

  saveRelayGeneration += 1;
  if (activeSaveRelayRequest && activeSaveRelayRequest.readyState !== 4) {
    activeSaveRelayRequest.abort();
    activeSaveRelayRequest = null;
  }

  if (!hadPersistedRelay) {
    return null;
  }

  const generation = ++clearRelayGeneration;
  if (activeClearRelayRequest && activeClearRelayRequest.readyState !== 4) {
    activeClearRelayRequest.abort();
  }

  activeClearRelayRequest = $.ajax({
    type: 'POST',
    url: MONDIALRELAY_AJAX_CHECKOUT_URL,
    data: {
      ajax: true,
      action: 'clearSelectedRelay',
      token: MONDIALRELAY_AJAX_CHECKOUT_TOKEN || (typeof static_token !== 'undefined' ? static_token : ''),
    },
    dataType: 'json',
    complete: function() {
      if (generation === clearRelayGeneration) {
        activeClearRelayRequest = null;
      }
    },
  });

  return activeClearRelayRequest;
};

$(document).ready(function() {
  removeCarrier();
});

$(document).on('click', widget.save_button, function(ev) {
  ev.preventDefault();
  ev.stopPropagation();

  widget.displayErrors(null);
  $(widget.summary_container).empty().show();
  widget.addLoader(widget.summary_container);

  $(widget).trigger('mondialrelay.saveSelectedRelay.before');

  clearRelayGeneration += 1;
  if (activeClearRelayRequest && activeClearRelayRequest.readyState !== 4) {
    activeClearRelayRequest.abort();
    activeClearRelayRequest = null;
  }

  let params = {
    ajax: true,
    action: 'saveSelectedRelay',
    token: MONDIALRELAY_AJAX_CHECKOUT_TOKEN || (typeof static_token !== 'undefined' ? static_token : ''),
    mondialrelay_selectedRelay: MONDIALRELAY_SELECTED_RELAY_IDENTIFIER ? MONDIALRELAY_SELECTED_RELAY_IDENTIFIER : 0,
    mondialrelay_selectedRelay_infos : MONDIALRELAY_SELECTED_RELAY_INFOS ? MONDIALRELAY_SELECTED_RELAY_INFOS : [],
    id_carrier: getSelectedCarrierId(),
  };

  const generation = ++saveRelayGeneration;
  if (activeSaveRelayRequest && activeSaveRelayRequest.readyState !== 4) {
    activeSaveRelayRequest.abort();
  }

  activeSaveRelayRequest = $.ajax(
  {
    type : 'POST',
    url: MONDIALRELAY_AJAX_CHECKOUT_URL,
    data : params,
    dataType: 'json',
    success: function(response) {
      if (generation !== saveRelayGeneration) {
        return;
      }

      if (!response) {
        this.error(response);
        return;
      }

      if (response.status == 'ok') {
        relaySelectionInvalidated = false;
        widget.savedRelay = MONDIALRELAY_SELECTED_RELAY_IDENTIFIER;
        $(widget.summary_container)
          .html(response.content.relaySummary);
        widget.hide();
        $(widget.save_container).hide();
        $(widget.widget_container).slideUp();
        $(widget.save_container).slideUp();
      } else {
        widget.savedRelay = null;
        if (response.error.length) {
          widget.displayErrors(response.error);
        }
        widget.removeLoader($(widget.summary_container));
        $(widget).trigger('mondialrelay.saveSelectedRelay.error');
        return;
      }

      $(widget).trigger('mondialrelay.saveSelectedRelay.success');
    },
    error: function(response) {
      if (generation !== saveRelayGeneration || response.statusText === 'abort') {
        return;
      }

      widget.savedRelay = null;
      alert(MONDIALRELAY_SAVE_RELAY_ERROR);
      $(widget).trigger('mondialrelay.saveSelectedRelay.error');
      widget.removeLoader($(widget.summary_container));
    },
    complete: function() {
      if (generation === saveRelayGeneration) {
        activeSaveRelayRequest = null;
      }
    }
  });

  return false;
});

const updateSaveRelayButtons = () => {
  const carrierId = getSelectedCarrierId();
  if (!carrierId) return;

  const mode = getCarrierDeliveryMode(carrierId);
  if (!mode) {
    $('#mondialrelay_save-container').hide();
    return;
  }

  // Always prepare the mode-specific save button, even when the whole
  // container must stay hidden (saved relay state).
  $('.mondialrelay_save-relay')
      .hide()
      .removeAttr('id');

  const $saveBtn = $(`.mondialrelay_save-relay[data-mr-mode="${mode}"]`);

  $saveBtn
      .attr('id', 'mondialrelay_save-relay')
      .show();

  const isSummaryVisible = $(widget.summary_container).is(':visible');
  const isWidgetHidden = $(widget.widget_container).is(':hidden');

  if (widget.savedRelay && (isSummaryVisible || isWidgetHidden)) {
    $('#mondialrelay_save-container').hide();
    return;
  }

  $('#mondialrelay_save-container').show();

  $('#mondialrelay_content').parent().parent().css('max-height', '');
};

$(widget).on('mondialrelay.ready mondialrelay.selectedRelay', updateSaveRelayButtons);

$(document).on(
  'mondialrelay.contentRefreshed',
  '#mondialrelay_content',
  updateSaveRelayButtons
);

$(document).ready(() => {
  updateSaveRelayButtons();

  [
    'updatedDeliveryForm',
    'opcCarriersUpdated',
    'opcCarrierSelected',
  ].forEach((eventName) => {
    prestashop.on(eventName, updateSaveRelayButtons);
  });
});

export {
  isRelayCarrierSelected,
  isPersistedRelayValid,
  syncPersistedRelay,
  clearPersistedRelay,
  getSelectedCarrierId,
  getCarrierDeliveryMode,
  getRelaySelectionError,
  widget,
};
